module.exports = __webpack_public_path__ + "static/media/Hunter-Hicks.2f3c7cd5.jpg";